import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"

//Import Images
import profileImg from "../../assets/images/profile-img.png"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// Pages Components
import TopProducts from "modules/components/top-products"
import TopViews from "modules/components/top-views"
import CardUser from '../components/card-user'
import FMYTDWidget from '../components/fmytd'
import MiniWidget from '../components/mini-widget'
import ChartJsCard from "./charts/chart"
import OrdersCalendar from "./orders-calendar"
import QualityReport from "./quality-report"
import CategoryDistribution from "./category-distribution"

//i18n
import { withTranslation } from "react-i18next"
import EmployeeDashboard from "./EmployeeDashboard"

const Dashboard = () => {
  const authUser = JSON.parse(localStorage.getItem('authUser'))
  // Check both 'role' and 'user_role' to be safe, as seen in SidebarContent
  const userRole = (authUser?.role || authUser?.user_role || '').toLowerCase()

  const allowedRoles = ["superadmin", "admin", "owner"]

  // If user is not an administrator, render the Employee Dashboard
  if (!allowedRoles.includes(userRole)) {
    return <EmployeeDashboard />
  }

  return (
    <React.Fragment>
      <div className="page-content p-t-2">
        <MetaTags><title>Oralstop | Dashboard</title></MetaTags>

        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Dashboards" breadcrumbItem="Dashboards" />

          {/* Card User */}
          <CardUser />

          {
            userRole != 'owner' &&
            <>
              <Row>
                <Col md="12">
                  <MiniWidget />
                </Col>
              </Row>
              <Row>
                {/* Column 1: Stats & Client Rankings */}
                <Col xl="4" lg="6" md="12">
                  <FMYTDWidget />
                  <div className="mb-4" />
                  <TopViews />
                </Col>

                {/* Column 2: Quality & Product Distribution */}
                <Col xl="4" lg="6" md="12">
                  <QualityReport />
                  <div className="mb-4" />
                  <CategoryDistribution />
                </Col>

                {/* Column 3: Charts */}
                <Col xl="4" lg="12" md="12">
                  <ChartJsCard type="Order" />
                  <div className="mb-4" />
                  <ChartJsCard type="Invoice" />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <TopProducts />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <OrdersCalendar />
                </Col>
              </Row>
            </>
          }

        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
